<template>
  <div>
    <div class="row">
      <div class="col-12">
        <div class="card p-5">
          <div class="row">
            <div class="col-12">
              <b-form-select
                @change="onSchemeSelect"
                value-field="id"
                text-field="name"
                v-model="schemeId"
                :options="schemes"
              ></b-form-select>
            </div>

            <div class="col-12 mt-5" v-if="schemeId">
              <h3>Contributors Summary</h3>
              <p>List of all contributors with their current balance</p>
              <a
                class="btn btn-primary btn-sm text-white"
                @click="contributors"
              >
                <i class="lni lni-printer"></i> Print
              </a>
              <br /><br />
              <hr />
            </div>
          </div>

          <div class="row mt-4" v-if="schemeId">
            <!-- Date Selector -->
            <div class="col-12 mb-5">
              <h5 class="m-0">Select reporting period</h5>
              <div class="row mt-2">
                <div class="col-6">
                  <b-form-spinbutton
                    min="2000"
                    max="3000"
                    v-model="year"
                  ></b-form-spinbutton>
                </div>
                <div class="col-6">
                  <b-form-spinbutton
                    :formatter-fn="monthFormatter"
                    wrap
                    min="0"
                    max="12"
                    v-model="month"
                  ></b-form-spinbutton>
                </div>
              </div>
            </div>

            <!-- Financials -->
            <div class="col-md-6 col-lg-3 border">
              <div class="card h-100">
                <div class="card-header bg-white">
                  <h5>Financial</h5>
                </div>
                <div class="card-body">
                  <p>Financial report for selected period</p>
                </div>
                <div class="card-footer bg-white">
                  <button @click="financial()" class="btn btn-sm btn-primary">
                    <i class="lni lni-printer"></i> Print
                  </button>
                </div>
              </div>
            </div>

            <div class="col-md-6 col-lg-3 border">
              <div class="card h-100">
                <div class="card-header bg-white">
                  <h5>Contributions</h5>
                </div>
                <div class="card-body">
                  <b-form-select
                    v-model="planId"
                    :options="plans"
                    value-field="id"
                    text-field="name"
                  ></b-form-select>
                  <p>Contributions collected in selected period</p>
                </div>
                <div class="card-footer bg-white">
                  <button
                    @click="contributions()"
                    class="btn btn-sm btn-primary"
                  >
                    <i class="lni lni-printer"></i> Print
                  </button>
                </div>
              </div>
            </div>

            <div class="col-md-6 col-lg-3 border">
              <div class="card h-100">
                <div class="card-header bg-white">
                  <h5>Debits</h5>
                </div>
                <div class="card-body">
                  <p>Debits list for selected period</p>
                </div>
                <div class="card-footer bg-white">
                  <button @click="debits()" class="btn btn-sm btn-primary">
                    <i class="lni lni-printer"></i> Print
                  </button>
                </div>
              </div>
            </div>

            <div class="col-md-6 col-lg-3 border">
              <div class="card h-100">
                <div class="card-header bg-white">
                  <h5>Outstanding</h5>
                </div>
                <div class="card-body">
                  <b-form-select
                    v-model="planId"
                    :options="plansOutstanding"
                    value-field="id"
                    text-field="name"
                  ></b-form-select>
                  <p>List for outstanding collections</p>
                </div>
                <div class="card-footer bg-white">
                  <button @click="outstanding()" class="btn btn-sm btn-primary">
                    <i class="lni lni-printer"></i> Print
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import schemeRepo from "@/api/repos/schemeRepo";

export default {
  data() {
    return {
      organisation_id: localStorage.getItem("current_organisation_id"),
      loading: false,
      schemes: [{ id: null, name: "Please select a scheme" }],
      schemeId: null,
      planId: 0,
      plans: [],
      plansOutstanding: [],
      year: new Date().getFullYear(),
      month: 0,
      months: [
        "ALL",
        "JAN",
        "FEB",
        "MAR",
        "APR",
        "MAY",
        "JUN",
        "JUL",
        "AUG",
        "SEP",
        "OCT",
        "NOV",
        "DEC",
      ],
    };
  },

  mounted() {
    this.getSchemes();
  },

  methods: {
    monthFormatter(value) {
      return this.months[value];
    },
    onSchemeSelect(value) {
      var scheme = this.schemes.filter((x) => x.id == value)[0];
      this.plans = [
        { id: 0, name: "All Plans" },
        { id: "adhoc", name: "Ad Hoc" },
      ];
      this.plansOutstanding = [
        { id: 0, name: "All Plans" },
      ];
      scheme.plans.forEach((x) => this.plans.push(x));
      scheme.plans.forEach((x) => this.plansOutstanding.push(x));
    },
    async getSchemes() {
      try {
        let { data } = await schemeRepo.schemes(
          1,
          10000,
          "name",
          "asc",
          "",
          null
        );
        data.schemes.data.forEach((x) => this.schemes.push(x));
      } catch (e) {
        console.log(e);
      }
    },

    async contributors() {
      window.open(
        process.env.VUE_APP_API_PATH +
          `reports/contributors/${this.schemeId}?cid=${this.organisation_id}`
      );
    },
    async financial() {
      window.open(
        process.env.VUE_APP_API_PATH +
          `reports/financial/${this.schemeId}/${this.year}/${this.month}?cid=${this.organisation_id}`
      );
    },
    async outstanding() {
      window.open(
        process.env.VUE_APP_API_PATH +
          `reports/outstanding/${this.schemeId}/${this.planId}/${this.year}/${this.month}?cid=${this.organisation_id}`
      );
    },
    async debits() {
      window.open(
        process.env.VUE_APP_API_PATH +
          `reports/debits/${this.schemeId}/${this.year}/${this.month}?cid=${this.organisation_id}`
      );
    },
    async contributions() {
      window.open(
        process.env.VUE_APP_API_PATH +
          `reports/contributions/${this.schemeId}/${this.planId}/${this.year}/${this.month}?cid=${this.organisation_id}`
      );
    },
  },
};
</script>

<style>
</style>